if (!customElements.get('m-image-card-list')) {
  class ImageCardList extends HTMLElement {
    connectedCallback() {
      const container = this.querySelector('.swiper-container');
      if (!container) return;

      const perRow = parseInt(this.dataset.items, 10) || 4;
      const gap = parseInt(this.dataset.gap, 10) || 20;
      const navAbsolute = this.dataset.navStyle === 'absolute';

      const paginationEl = this.querySelector('.swiper-pagination');
      const nextEl = this.querySelector('.swiper-button-next');
      const prevEl = this.querySelector('.swiper-button-prev');

      const options = {
        slidesPerView: 1.15,
        spaceBetween: gap,
        slidesPerGroup: 1,
        watchOverflow: true,
        breakpoints: {
          480: {
            slidesPerView: Math.min(2, perRow)
          },
          768: {
            slidesPerView: Math.min(3, perRow)
          },
          1280: {
            slidesPerView: perRow
          }
        }
      };

      if (paginationEl) {
        options.pagination = { el: paginationEl, clickable: true };
      }
      if (nextEl && prevEl) {
        options.navigation = { nextEl, prevEl };
      }

      this.slider = new MinimogLibs.Swiper(container, options);

      // Nav-only mode: the vendor's ".m-slider-controls--absolute" positions the
      // prev/next buttons via a CSS var (--offset-top) that only centers correctly
      // once it's set from JS to half the slide row's height (same pattern used by
      // the theme's other absolute-positioned sliders, e.g. m-featured-slider).
      if (navAbsolute && prevEl && nextEl) {
        const controls = this.querySelector('.m-slider-controls');
        const positionArrows = () => {
          const height = container.clientHeight;
          if (!height) return;
          const offset = (height / 2) + 'px';
          prevEl.style.setProperty('--offset-top', offset);
          nextEl.style.setProperty('--offset-top', offset);
          if (controls) controls.classList.remove('m:hidden');
        };
        setTimeout(positionArrows, 200);
        this.slider.on('resize', positionArrows);
      }
    }
  }
  customElements.define('m-image-card-list', ImageCardList);
}
